import { render, staticRenderFns } from "./PatientForm.vue?vue&type=template&id=37f11b06&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=js"
export * from "./PatientForm.vue?vue&type=script&lang=js"
import style0 from "./PatientForm.vue?vue&type=style&index=0&id=37f11b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f11b06",
  null
  
)

export default component.exports